<template>
  <div>
    <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <div class="">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10 pt-4">
              <div class="row headercontenido">
                <div class="col-12">
                  <span class="titulo bold">Configuración "{{nombre}}"</span>
                </div>
              </div>

              <div class="contenido">
                <form
                  class="row mx-3"
                  method="post"
                  @submit="submitFormulario($event)"
                >
                  <div
                    class="formulario col-12 bg-white shadow p-4 rounded card"
                  >
                    <div class="row">
                      <div class="col-12">
                        <i class="fas fa-cogs fM2"></i>
                        <span class="fM2 bold"> Automatización </span>
                      </div>
                    </div>

                    <hr />

                   

                   

                    <div class="row">

                      <div class="col-12">
                         % Cobertura Básica
                      </div>

                      
                      <div class="col-md-12 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <input type="number" v-model="form.cobertura_basica" />
                          </label>
                        </div>
                      </div>

                      <div class="col-12">
                        En caso de que la dirección de correo electrónico del
                        cliente no acepte el correo con el certificado,
                        notificar a (separar correos con una coma):
                      </div>

                      
                      <div class="col-md-12 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <textarea
                              class="p-4"
                              v-model="form.error_correo"
                              id=""
                              cols="30"
                              rows="5"
                            >
                            </textarea>
                          </label>
                        </div>
                      </div>


                      <div class="col-md-12 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <span>Enviar copia de certificado a (separar correos con una coma):</span>
                            <textarea
                              class="p-4"
                              v-model="form.copia_certificado"
                              id=""
                              cols="30"
                              rows="5"
                            >
                            </textarea>
                          </label>
                        </div>
                      </div>


                      <div class="col-md-12 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <span>Nota para PDF de certificado, endoso, renovación:</span>
                            <textarea
                              class="p-4"
                              v-model="form.nota"
                              id=""
                              cols="30"
                              rows="5"
                            >
                            </textarea>
                          </label>
                        </div>
                      </div>

                      <div class="col-md-12 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <span
                              >Razón Social (remitente en correos):</span
                            >
                            <input
                              type="text"
                              v-model="form.razon_social"
                              maxlength="500"
                            />
                          </label>
                        </div>
                      </div>

                      <div class="col-md-12 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <span
                              >Teléfono 1 (remitente en correos):</span
                            >
                            <input
                              type="text"
                              v-model="form.telefono_1"
                              maxlength="220"
                            />
                          </label>
                        </div>
                      </div>

                      <div class="col-md-12 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <span
                              >Teléfono 2 (remitente en correos):</span
                            >
                            <input
                              type="text"
                              v-model="form.telefono_2"
                              maxlength="220"
                            />
                          </label>
                        </div>
                      </div>

                      <div class="col-md-12 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <span
                              >Celular (remitente en correos):</span
                            >
                            <input
                              type="text"
                              v-model="form.celular"
                              maxlength="220"
                            />
                          </label>
                        </div>
                      </div>

                      <div class="col-md-12 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <span
                              >Nombre Responsable (remitente en correos):</span
                            >
                            <input
                              type="text"
                              v-model="form.nombre_contacto"
                              maxlength="220"
                            />
                          </label>
                        </div>
                      </div>

                      <div class="col-md-12 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <span
                              >Correo de contacto (remitente en correos):</span
                            >
                            <input
                              type="email"
                              v-model="form.correo_contacto"
                              maxlength="220"
                            />
                          </label>
                        </div>
                      </div>

                      <!-- <div class="col-md-12 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <span
                              >Horas de retardo en envío de certificado para el
                              cliente :</span
                            >
                            <input
                              type="text"
                              v-model="form.delay_certificado"
                            />
                          </label>
                        </div>
                      </div> -->
                    </div>

                    <div class="row">
                      <div class="col-12 text-center">
                        <button type="submit" class="submit btnnaranja">
                          Guardar cambios
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Menu from "../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import moment from "moment";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "GAIG",
  props: {
    msg: String,
  },
  data() {
    return {
      paso: 1,
      id_contratante: "",
      nombre: "",
      form: {
        cobertura_basica: "",
        error_correo: "",
        copia_certificado: "",
        delay_certificado: "",
        nota: "",
        razon_social: "",
        telefono_1: "",
        telefono_2: "",
        celular: "",
        nombre_contacto: "",
        correo_contacto: "",
      },
      tiposervicio: "",
      columns: [
        "nombre",
        "email",
        "no_poliza",
        "no_certificado",
        "uri",
        // "baja",
        // "bloqueo"
      ],
      datos: null,
      data: null,
      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          matricula: "Matrícula",
          nombre: "Nombre",
          email: "Email",
          no_poliza: "No. de póliza",
          no_certificado: "No. de certificado",
          uri: "Detalle",
          baja: "Baja",
          bloqueo: "Bloqueo",
        },
        editableColumns: ["name"],
        sortable: [],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed",
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Buscar registro",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu,
  },
  mounted: function () {
    this.$store.state.user = JSON.parse(this.$cookie.get("usergaig"));
    AOS.init();

    this.id_contratante = this.$route.params.id;
    console.log(this.id_contratante);

    this.consultaOpciones();
  },
  methods: {
    consultaOpciones() {
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = this.form;
      qData["admin_id"] = this.id_contratante;

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "consulta-opciones-admin.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.nombre = res.contratante;
              this.form.cobertura_basica = res.cobertura_basica;
              this.form.error_correo = res.error_correo;
              this.form.copia_certificado = res.copia_certificado;
              this.form.delay_certificado = res.delay_certificado;
              this.form.nota = res.nota;
              this.form.razon_social = res.razon_social;
              this.form.telefono_1 = res.telefono_1;
              this.form.telefono_2 = res.telefono_2;
              this.form.celular = res.celular;
              this.form.nombre_contacto = res.nombre_contacto;
              this.form.correo_contacto = res.correo_contacto;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    razonSocialChange(e) {
      if (!this.form.usar_razon_social) {
        this.form.razon_social = "";
      } else {
        this.form.rfc = "";
        this.form.nombre = "";
        this.form.apellido_paterno = "";
        this.form.apellido_materno = "";
      }
    },
    continuar() {
      this.paso++;

      if (this.paso == 5) {
        //calcular prima, iva, etc
        let valor_factura = this.form.valor_factura;
        let prima_neta = 0;
        if (valor_factura > 0) {
          //calcular prima neta
          if (valor_factura <= 50000) {
            this.form.prima_neta = 862.06;
          } else if (valor_factura <= 100000) {
            this.form.prima_neta = parseFloat(valor_factura * 0.052).toFixed(2);
          } else if (valor_factura <= 300000) {
            this.form.prima_neta = parseFloat(valor_factura * 0.0315).toFixed(
              2
            );
          } else {
            this.form.prima_neta = parseFloat(valor_factura * 0.0315).toFixed(
              2
            );
          }

          //calcular derechos de poliza
          if (this.form.prima_neta <= 1000) {
            this.form.derecho_de_poliza = 125.0;
          } else if (this.form.prima_neta <= 5000) {
            this.form.derecho_de_poliza = 250.0;
          } else if (this.form.prima_neta <= 10000) {
            this.form.derecho_de_poliza = 325.0;
          } else if (this.form.prima_neta <= 30000) {
            this.form.derecho_de_poliza = 500.0;
          } else {
            this.form.derecho_de_poliza = 700.0;
          }

          //calcular iva
          this.form.iva = parseFloat(
            (parseFloat(this.form.prima_neta) +
              parseInt(this.form.derecho_de_poliza)) *
              0.16
          ).toFixed(2);
          this.form.prima_total = parseFloat(
            parseFloat(this.form.prima_neta) +
              parseInt(this.form.derecho_de_poliza) +
              parseFloat(this.form.iva)
          ).toFixed(2);
        }
      }
    },
    regresar() {
      this.paso--;
    },
    submitFormulario(e) {
      //terminar
      e.preventDefault();

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = this.form;
      qData["admin_id"] = this.id_contratante;

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "actualiza-opciones-admin.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");

              swal
                .fire({
                  title: "Configuración",
                  html: res.msg,
                  confirmButtonText: `Ok`,
                  icon: "success",
                })
                .then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    //this.$router.push("/dashboard");
                  }
                });
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    changeVigenciaIni() {
      console.log(this.form.vigencia_ini);
      let date = new Date(this.form.vigencia_ini);
      date.setFullYear(date.getFullYear() + 1);
      this.form.vigencia_fin =
        this.formatDate(date) + "T" + this.formatTime(date);

      //console.log(this.form.vigencia_fin);
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    formatTime(date) {
      var d = new Date(date),
        hour = "" + d.getHours(),
        minute = "" + d.getMinutes();

      if (hour.length < 2) hour = "0" + hour;
      if (minute.length < 2) minute = "0" + minute;

      return [hour, minute].join(":");
    },
  },
};
</script>

